import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input } from '@angular/core';
import { ActiveSessionsService } from '../../../../core/services/active-sessions.service';
import { AlertService, CountryNamePipe, DialogService } from '@wm-libs/core';
import { RouteService } from '../../../../core/services/route.service';
import { UserService } from '@wm-libs/core';
import { StorageService } from '@wm-libs/core';
import { map } from 'rxjs';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Session } from '../../../../core/interfaces/sessions.interface';
import { NgIf, NgClass, NgFor, AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-active-sessions',
  templateUrl: './active-sessions.component.html',
  styleUrls: ['./active-sessions.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, NgFor, AsyncPipe, TranslateModule, CountryNamePipe],
})
export class ActiveSessionsComponent {
  @Input() activeSessions!: Session[];
  displayedSessionsCount = 2;

  isTablet$ = this.breakpointObserver.observe([Breakpoints.Small]).pipe(map((result) => result.matches));

  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall]).pipe(map((result) => result.matches));

  constructor(
    private breakpointObserver: BreakpointObserver,
    private alertService: AlertService,
    private routeService: RouteService,
    private activeSessionsService: ActiveSessionsService,
    private userService: UserService,
    private storageService: StorageService,
    private translate: TranslateService,
    private dialogService: DialogService,
    private translateService: TranslateService
  ) {}

  deleteSpecificSession(id: number, currentSession: boolean) {
    this.activeSessionsService.deleteSpecificSession(id).subscribe((res) => {
      this.activeSessions = res;
      this.alertService.showAlert(this.translateService.instant('WM_TECH_POOL.SESSIONS.LOGGED_OUT'), 'success');

      if (currentSession) {
        this.currentSessionLogOut();
      }
    });
  }

  calculateLastActive(lastActiveDate: string): string {
    const lastActive = new Date(lastActiveDate);
    const now = new Date();
    const diffInMilliseconds = Math.abs(now.getTime() - lastActive.getTime());

    const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
    const diffInWeeks = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24 * 7));
    const diffInMonths = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24 * 30));
    const diffInYears = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24 * 365));

    if (diffInMinutes < 3) {
      return `${this.translate.instant('WM_TECH_POOL.SESSIONS.ONLINE')}`;
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes} ${this.translate.instant('WM_TECH_POOL.SESSIONS.MINUTES_AGO')}`;
    } else if (diffInHours < 24) {
      return `${diffInHours} ${this.translate.instant('WM_TECH_POOL.SESSIONS.HOURS_AGO')}`;
    } else if (diffInDays < 7) {
      return `${diffInDays} ${this.translate.instant('WM_TECH_POOL.SESSIONS.DAYS_AGO')}`;
    } else if (diffInWeeks < 4) {
      return `${diffInWeeks} ${this.translate.instant('WM_TECH_POOL.SESSIONS.WEEKS_AGO')}`;
    } else if (diffInMonths < 12) {
      return `${diffInMonths} ${this.translate.instant('WM_TECH_POOL.SESSIONS.MONTHS_AGO')}`;
    } else {
      return `${diffInYears} ${this.translate.instant('WM_TECH_POOL.SESSIONS.YEARS_AGO')}`;
    }
  }

  showMore() {
    this.displayedSessionsCount += 3;
  }

  currentSessionLogOut() {
    this.storageService.removeToken();
    this.userService.setAuthenticated(false);
    this.routeService.goToLogin();
  }

  deleteActiveSessions() {
    const config = {
      image: 'assets/images/settings/warning.png',
      imageAlt: 'warning',
      title: 'WM_TECH_POOL.SESSIONS.DIALOG.TITLE',
      app: 'tech',
      fields: [{ name: 'keepCurrent', label: 'WM_TECH_POOL.SESSIONS.DIALOG.KEEP_THIS', type: 'checkbox', value: true, validators: [] }],
    };

    const dialogRef = this.dialogService.openPopup(config);

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.keepCurrent) {
        this.activeSessionsService.deleteActiveSessions(result.keepCurrent).subscribe(() => {
          this.alertService.showAlert(this.translateService.instant('SESSIONS.LOGGED_OUT'), 'success');
          if (!result.keepCurrent) {
            this.currentSessionLogOut();
          }
          if (this.activeSessions?.length) {
            this.activeSessions = this.activeSessions.filter((item: { current: boolean }) => item.current === true);
          }
        });
      }
    });
  }
}
